import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockCountdown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_795_1665)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24.5 14.875C24.0548 20.265 19.5048 24.5 14 24.5C11.2152 24.5 8.54451 23.3938 6.57538 21.4246C4.60625 19.4555 3.5 16.7848 3.5 14C3.5 8.49516 7.735 3.94516 13.125 3.5",
				stroke: "#846701",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 7.875V14H20.125",
				stroke: "#846701",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.5 5.25C18.2249 5.25 18.8125 4.66237 18.8125 3.9375C18.8125 3.21263 18.2249 2.625 17.5 2.625C16.7751 2.625 16.1875 3.21263 16.1875 3.9375C16.1875 4.66237 16.7751 5.25 17.5 5.25Z",
				fill: "#846701"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.4375 7.875C22.1624 7.875 22.75 7.28737 22.75 6.5625C22.75 5.83763 22.1624 5.25 21.4375 5.25C20.7126 5.25 20.125 5.83763 20.125 6.5625C20.125 7.28737 20.7126 7.875 21.4375 7.875Z",
				fill: "#846701"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.0625 11.8125C24.7874 11.8125 25.375 11.2249 25.375 10.5C25.375 9.77513 24.7874 9.1875 24.0625 9.1875C23.3376 9.1875 22.75 9.77513 22.75 10.5C22.75 11.2249 23.3376 11.8125 24.0625 11.8125Z",
				fill: "#846701"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_795_1665",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgClockCountdown;
